"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.convertFilterToRegex = function (topic) {
  return new RegExp("^" + topic.replace(/\+/g, "[\\w-]*").replace(/#/g, "[\\w/-]*" + "$"));
};